let participant = {
	firstname: "",
	lastname: "",
	email: "",
	telephone: "",
	location: "",
	creneau: "",
	newsletter: 0,
};

const resultDiv = document.getElementById("result-indicator");
const iconResult = document.getElementById("icon-result");
const resultMessage = document.getElementById("result-message");
const spinner = document.getElementById("spinner");
const submitBtn = document.getElementById("submit-btn");
const newsletterInput = document.getElementById("newsletter");
const requirement = document.getElementById("requirement");
const firstnameInput = document.getElementById("firstname");
const lastnameInput = document.getElementById("lastname");
const emailInput = document.getElementById("email");
const phoneInput = document.getElementById("phone");
const creneauInput = document.getElementById("creneau");
const locationInput = document.getElementById("location");
const locationAndCreneauInput = document.getElementById("locationCreneau");
const formError = document.getElementById("form-error");
const form = document.getElementById("event-form");
const scrollToFormBtn = document.getElementById('scroll-to-form');

// Si bouton pour scroller sur formulaire, écoute sur le click
if(scrollToFormBtn) {
	scrollToFormBtn.addEventListener('click', function (event) {
		// Calculate the scroll position to the target element
		const targetPosition = form.getBoundingClientRect().top + window.scrollY - 120;

		// Scroll to the target element with smooth easing
		window.scrollTo({
			top: targetPosition,
			behavior: 'smooth'
		});
	});
}

function submitForm() {
	participant.firstname = firstnameInput.value;
	participant.lastname = lastnameInput.value;
	participant.email = emailInput.value;
	participant.newsletter = newsletterInput.checked;
	participant.telephone = phoneInput.value;

	if(creneauInput) participant.creneau = creneauInput.value;
	if(locationInput) participant.location = locationInput.value;
	if(locationAndCreneauInput) {
		let locationAndCreneau = locationAndCreneauInput.value;
		// La valeur de l'option est au format JSON
		locationAndCreneau = JSON.parse(locationAndCreneau);
		participant.location = locationAndCreneau.location;
		participant.creneau = locationAndCreneau.creneau;
	}

	submitBtn.classList.add('on-submit');
	formError.textContent = "";
	formError.classList.remove("form-has-errors");

	grecaptcha.ready(function () {
		grecaptcha
			.execute(captchaSecretKey, { action: "submit" })
			.then(function (token) {
				if (!token) {
					displayFormError("Vérification anti-robot impossible");
				} else {
					$.ajax({
						type: "POST",
						url: formAjaxUrl,
						data: JSON.stringify({
							participant: participant,
							postID: postID,
						}),
						dataType: "json",
						contentType: "application/json",
						timeout: 5000,
						success: function (response) {
							if (response) {
								if (response.error) {
									displayFormError(response.error);
								} else {
									displayFormSuccess();
								}
							} else {
								displayFormError(
									"Impossible d'envoyer le formulaire, veuillez réessayer."
								);
							}
						},
						error: function (xhr, status, error) {
							displayFormError(
								"Impossible d'envoyer le formulaire, veuillez réessayer."
							);
						},
					});
				}
			});
	});
}

function displayFormError(error = "") {
	formError.textContent = error;
	formError.classList.add("form-has-errors");
	submitBtn.classList.remove('on-submit');
}

function validateForm() {
	// Reset previous error messages
	formError.textContent = "";
	formError.classList.remove("form-has-errors");

	// Validate name (required)
	if (firstnameInput.value === "") {
		displayFormError("Veuillez renseigner votre prénom");
		return false;
	}

	// Validate name (required)
	if (lastnameInput.value === "") {
		displayFormError("Veuillez renseigner votre nom");
		return false;
	}

	// Validate email (required and format)
	const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
	if (emailInput.value === "" || !emailPattern.test(emailInput.value)) {
		displayFormError("Veuillez renseigner une adresse mail valide");
		return false;
	}

	submitForm();
	return false;
}

function displayFormSuccess() {
	form.classList.add('submit-success');
}
